import { BREAKPOINTS } from './constants';

export const isMobileScreen = (mobileBreakpoint = BREAKPOINTS.MD) => window.innerWidth < mobileBreakpoint;
export const isXxlScreen = (xxlBreakpoint = BREAKPOINTS.XXL) => window.innerWidth >= xxlBreakpoint;

export const detectVisibleItem = (items, cb, threshold = 0.8) => {
  const observer = new IntersectionObserver((entries) =>
    entries.forEach((entry) => entry.intersectionRatio >= threshold ? cb(entry?.target) : null)
  , { threshold: threshold });

  items.forEach((item) =>
    observer.observe(item)
  );
};

export const convertStringToNumber = (value) => Number(value.replace(/[^0-9]/g, ''));

export const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const queryBuilder = (query) => {

  const url = location.href;
  const stringUrl = url.toString();

  const hasQuery = stringUrl?.indexOf('?');
  const oldQuery = stringUrl.substring(hasQuery, stringUrl?.length);

  let newQuery = oldQuery;

  for (const [key, value] of Object.entries(query)) {
    newQuery = replaceUrlParam(newQuery, key, value);
  }

  history.replaceState(null, null, newQuery);
};

export const clearQuery = () => {

  const url = location.href;
  const stringUrl = url.toString();

  const hasQuery = stringUrl?.indexOf('?');

  if (!hasQuery) return;
  const newUrl = stringUrl.substring(0, hasQuery);

  history.pushState({ path: newUrl }, '', newUrl);
};

const replaceUrlParam = (url, paramName, paramValue) => {

  if (paramValue === null || paramValue === '') return removeParam(url, paramName);

  const pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');

  if (url.search(pattern) >= 0) return url.replace(pattern, '$1' + paramValue + '$2');
  url = url.replace(/[?#]$/, '');

  return url + (url.indexOf('?') > -1 ? '&' : '?') + paramName + '=' + paramValue;
};

const removeParam = (url, paramName) => {
  const pattern = new RegExp('[?&]' + paramName + '=[^&#]*[&#]?', 'g');
  return url.replace(pattern, '').replace(/[?&]$/, '');
};

export const getParamFromUrl = (param) => {
  if (!param) return;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  return urlParams.get(param);
};

export const currencyFormater = (value) => {
  const formatedPrice = new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(convertStringToNumber(value));

  return formatedPrice;
};

export function debounce(func, delay = 300) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}
